import { render, staticRenderFns } from "./SubmitCounterDelete.vue?vue&type=template&id=6abd19e0&scoped=true"
import script from "./SubmitCounterDelete.vue?vue&type=script&lang=js"
export * from "./SubmitCounterDelete.vue?vue&type=script&lang=js"
import style0 from "./SubmitCounterDelete.vue?vue&type=style&index=0&id=6abd19e0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6abd19e0",
  null
  
)

export default component.exports